import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Input } from 'antd';
import { Text } from 'components';

const CriteriosDeResolucion = ({ criterios }) => {
  if (!criterios?.length) return null;

  return (
    <>
      <Text $accent $bold>Criterios de resolución</Text>
      <ul style={{ paddingLeft: 20 }}>
        {criterios.map((criterio) => (
          <li key={criterio.id}>
            <TextArea
              readOnly
              bordered={false}
              autoSize={{ minRows: 1, maxRows: Number.MAX_SAFE_INTEGER }}
              value={criterio.criterio}
            />
          </li>
        ))}
      </ul>
    </>
  );
};

const TextArea = styled(Input.TextArea)`
  font-size: 18px;
`;

CriteriosDeResolucion.propTypes = {
  criterios: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    criterio: PropTypes.string,
  })),
};

CriteriosDeResolucion.defaultProps = {
  criterios: [],
};

export default CriteriosDeResolucion;
